import React from "react";
import { LabelBadge } from "./LabelBadge";
import { Label } from "@api/graphql/generated/generated-types";

interface LabelListProps {
  labels: Label[];
}

export function LabelList({ labels }: LabelListProps) {
  if (!labels || labels.length === 0) {
    return <div className="text-gray-500 text-sm">No labels found</div>;
  }

  return (
    <>
      {labels.map((label) => (
        <LabelBadge key={label.id} label={label} />
      ))}
    </>
  );
}
